module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/240-azores-islands-49558dc54825e9d3c44d761dd4bc68bc.svg";